import { styled } from 'baseui'
import { CALLBACK_REMINDER_STACK_BOTTOM } from '@/shared/theme/callbackReminderSpace'

export const ReminderStack = styled('section', {
  position: 'fixed',
  bottom: CALLBACK_REMINDER_STACK_BOTTOM,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1150,
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '0.5rem',
  width: 'min(52.5rem, max(30rem, calc(100vw - 26rem)), calc(100vw - 2rem))',
  maxHeight: 'calc(100vh - 9rem)',
  overflowY: 'auto',
})
